


















































































































































































































































import { DataTableAction, DataTableField, DataTableMultiAction, DataTableSort } from "@/components/data/data-table";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class DataTable extends Vue {
    // Data
    query: string = "";
    sort: DataTableSort<never> = {
        field: null,
        direction: null,
    };

    @Prop({ required: true })
    fields: DataTableField<never>[];

    @Prop()
    actions: DataTableAction<never>[];

    @Prop({ required: true })
    items: { [key: string]: never }[];

    @Prop({ required: false })
    pages: number;

    @Prop({ required: false })
    page: number;

    @Prop({ default: false })
    loading: Boolean;

    @Prop({ default: false })
    hideSearch: Boolean;

    @Prop()
    searchDataCy: string;

    @Prop({ default: false })
    showFilters: Boolean;

    @Prop()
    initialSort: DataTableSort<never>;

    @Prop({ default: false })
    multiSelect: boolean;

    @Prop({ default: false })
    multiSelectActions: DataTableMultiAction<never>[];

    selectedItems: any[] = [];

    created() {
        if (this.initialSort) this.sort = Object.assign({}, this.initialSort);
    }

    get displayedItems() {
        return this.$props.items.filter((i) => {
            for (const key of Object.getOwnPropertyNames(i)) {
                if (typeof i[key] === "string" && i[key].toLowerCase().includes(this.query.toLowerCase())) return true;
            }
        });
    }

    @Watch("selectedItems")
    emitSelectedItems(val) {
        this.$emit("selection", val);
    }

    sortBy(field: DataTableField<never>) {
        if (this.sort.field === field.field) {
            // Already sorting by this field - simply negate it
            this.$set(this.sort, "direction", this.sort.direction * -1);
        } else {
            // This way, vue is aware of the change
            this.$set(this.sort, "field", field.field);
            this.$set(this.sort, "direction", 1);
        }

        // Todo: this should NOT be necessary. What the frick frack is going on?
        this.$forceUpdate();

        // Create a new object so external watchers properly trigger
        this.$emit("sort", Object.assign({}, this.sort));
    }

    getNestedField(object: { [key: string]: any }, path: string): any {
        // One-liner from https://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-and-arays-by-string-path
        return path.split(".").reduce((p, c) => (p && p[c]) || undefined, object);
    }

    @Watch("page")
    @Watch("items")
    clearSelection() {
        this.selectedItems = [];
    }

    toggleSelectAll() {
        if (this.allItemsSelected) this.clearSelection();
        else this.selectedItems = this.items.slice();
    }

    toggleSelection(item: any) {
        if (this.isItemSelected(item)) this.selectedItems = this.selectedItems.filter((i) => i !== item);
        else this.selectedItems.push(item);
    }

    get allItemsSelected() {
        return this.selectedItems.length === this.items.length && this.items.length > 0;
    }

    isItemSelected(item: any) {
        return this.selectedItems.includes(item);
    }
}
